import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { BsModalRef } from "ngx-bootstrap";
import { DatePipe } from "@angular/common";
import { FeeType } from '../../../../../../../projects/accounting/src/public_api';

export interface ApplicationEditorData {
  address: string;
  type: FeeType
}

@Component({
  selector: 'app-confirm-fee',
  templateUrl: './application-editor.component.html',
  styleUrls: ['./application-editor.component.scss']
})
export class ApplicationEditorComponent implements OnInit {

  @Input() data: ApplicationEditorData;
  @Output() commit = new EventEmitter();

  message = '';

  public since = new Date();
  public amount: number = 0;

  public config = {
    containerClass: 'theme-angle custom-date',
    dateInputFormat: 'DD-MM-YYYY'
  };

  public amountRequired: boolean;
  public address1: string;
  public address2: string;
  constructor(
    public modal: BsModalRef,
    private date: DatePipe,
  ) { }

  ngOnInit() {

    this.amountRequired = this.data.type == FeeType.oneTime || this.data.type == FeeType.unpredictable;
    this.address1 = this.data.address.split(',')[0];
    this.address2 = this.data.address.substr(this.address1.length + 1).trim();
    this.address1 = this.address1.trim();
  }

  update($event) {

    if (this.amountRequired) {
      this.amount = $event.target.value;
      this.message = this.amount <= 0 ? "Số tiền không được nhỏ hơn hoặc bằng 0" : "";
    }
  }


  emit() {

    if (!this.amountRequired || this.amount > 0) {
      this.commit.emit({ amount: this.amount, date: this.date.transform(this.since, 'dd-MM-yyyy') });
      this.modal.hide();
    }
    else {
      this.message = "Số tiền không được nhỏ hơn hoặc bằng 0";
    }
  }
}
